"use client";

import pick from "lodash/pick";
import { useSearchParams } from "next/navigation";

type UtmDataType = Partial<{
  utm_source: string;
  utm_medium: string;
  utm_term: string;
  utm_content: string;
  utm_device: string;
  utm_campaign: string;
  utm_adgroup: string;
  utm_location: string;
  utm_channel: string;
  utm_variety: string;
  gclid: string;
}>;

function useUtmParams(): UtmDataType {
  const searchParams = useSearchParams();

  const paramsObj: Record<string, string> = {};
  searchParams.forEach((value, key) => {
    paramsObj[key] = value;
  });

  const pickOnly = [
    "utm_source",
    "utm_medium",
    "utm_term",
    "utm_content",
    "utm_device",
    "utm_campaign",
    "utm_adgroup",
    "utm_location",
    "utm_channel",
    "utm_variety",
    "gclid",
  ];
  const utmParams = pick(paramsObj, pickOnly);

  return utmParams;
}
export default useUtmParams;
